import React from 'react';
import { View, Text, RefreshControl, TouchableOpacity, StyleSheet, Platform, ScrollView, Dimensions, Alert } from 'react-native';
import { FlashList } from '@shopify/flash-list';
import CS from '../../constants/Styles';
import { BackgroundGradient, Storage, Loader }  from '../../components';
import * as rtApi from '../../components/Api';
import Colors from '../../constants/Colors';
import ProjectPreview from '../../components/Projects/ProjectPreview';
import { Ionicons } from '@expo/vector-icons';
import { useFocusEffect } from '@react-navigation/native';
// import * as SecureStore from 'expo-secure-store';
import * as LocalAthentication from 'expo-local-authentication';
import UserState from '../../src/contexts/UserState';
import SelectBox from 'react-native-multi-selectbox';
import Carousel, { Pagination } from 'react-native-snap-carousel';
import { isLocalAuthenticationAvailable } from '../../utils/Functions';
import * as Device from 'expo-device';
import { useLinkTo } from '@react-navigation/native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export default function Projects({ navigation }) {
  const [user, setUser] = React.useContext(UserState);
  const [projects, setProjects] = React.useState([]);
  const [addresses, setAddresses] = React.useState([]);
  const allAddresses = { item: 'All addresses', id: 'all' };
  const [selectedAddress, setSelectedAddress] = React.useState(allAddresses);
  const [completedProjects, setCompletedProjects] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [isTablet, setIsTablet] = React.useState(false);
  const [isWeb, setIsWeb] = React.useState(Platform.OS === 'web');
  const [isReady, setIsReady] = React.useState(false);
  const [showSeeAll, setShowSeeAll] = React.useState(false);

  let scrollRef = React.useRef(null);
  let carouselRef = React.useRef(null);
  const screenWidth = Dimensions.get('window').width;
  const insets = useSafeAreaInsets();
  console.log('screedWidth: ', screenWidth);
  const SLIDER_WIDTH = screenWidth - 20; // 20 is screen margin
  const linkTo = useLinkTo();
  
  // let addresses = [];
  
  // setSelectedAddress(allAddresses);

  useFocusEffect(
    React.useCallback(() => {
      getProjects(selectedAddress);
      navigation.setOptions({ title: "Projects" });
    }, [])
  );

  React.useEffect(() => {
    // this refreshes projects when on projects screen
    const unsubscribe = navigation.getParent().addListener('tabPress', (e) => {
      console.log('tabPress');
      scrollRef.current.scrollTo({ x: 0, y: 0, animated: true });
      getProjects(selectedAddress);
      navigation.setOptions({ title: "Projects" });
    });
    return unsubscribe;
  }, [navigation]);

  React.useEffect(() => {
    (async () => {
      const deviceType = await Device.getDeviceTypeAsync();
      console.log('deviceType: ', deviceType);
      setIsTablet(deviceType === Device.DeviceType.TABLET ? true : false);
      setIsReady(true);
    })()
    return () => rtApi.cancel();
  }, []);

  const getProjects = async (search) => {
    console.log('getProjects ProjectsScreen: ', search);
    setLoading(true);
    let query = (search === undefined || search.id === 'all') ? '' : `?address=${encodeURIComponent(search.item)}`;
    rtApi.get(`agreements${query}`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      let projects = data.agreements.filter(p => {
        return p.stage !== 'Completed';
      });
      let completed = data.agreements.filter(p => {
        return p.stage === 'Completed';
        // return true; // testing to see completed when there isn't any
      });
      if(completed.length > 8){
        console.log('restrict completed to 4...')
        completed = completed.splice(0, 8);
        setShowSeeAll(true);
      }
      // completed.forEach(c => {
      //   c.image = require('../../assets/img/default_project2.jpg')
      // })
      setProjects(projects);
      setCompletedProjects(completed);
      let addresses = [allAddresses];
      data.addresses.forEach((a, i) => { addresses.push({ item: a, id: i+'' }); });
      console.log('addresses: ', addresses);
      console.log('completed: ', completedProjects);
      setAddresses(addresses);
    })
    .catch((err) => {
      console.log('getProjects catch', err);
      // if(!err.isLoggedIn){ set}
    })
    .finally(() => {
      setLoading(false);
    });
  }

  const newProject = () => {
    console.log('newProduct()');
    linkTo('/projects/create_project_tutorial');
  }

  let localAuthenticationModalMessage = 'Would you like to use biometrics the next time you log in?';
  let localAuthenticationModalTitle = 'Use Biometrics?'; 
  React.useEffect(() => {
    setTimeout(() => {
      checkLocalAuthentication();
    }, 1500);
  }, []);
  const checkLocalAuthentication = async () => {
    console.log('checkLocalAuthentication ');
    // let useLocalAthentication = await SecureStore.getItemAsync('useLocalAuthentication');
    let useLocalAthentication = await Storage.getItem('useLocalAuthentication');
    console.log('useLocalAthentication', useLocalAthentication);
    if (useLocalAthentication === null && user.type === 'Email') {
    // if (useLocalAthentication === 'no') { //testing
      // prompt to use local authentication next time for login
      let isLocalAuthenticationAvailableResult = await isLocalAuthenticationAvailable();
      console.log('isLocalAuthenticationAvailableResult', isLocalAuthenticationAvailableResult);
      if (isLocalAuthenticationAvailableResult) {
        getLocalAuthenticationMessage();
        // console.log('showing modal....', localAuthenticationModalMessage);
        // // setShowLocalAthenticationModal(true);
        // showLocalAuthenticationAlert(localAuthenticationModalTitle, localAuthenticationModalMessage);
      }
    }
  }
  const getLocalAuthenticationMessage = async () => {
    let supportedAuthenticationTypesAsync = await LocalAthentication.supportedAuthenticationTypesAsync();
    let loginSupported = user.type === 'Email' ? 'login, ' : '';
    // 1 fingerint - 2 facial
    let title = 'Use Local Authentication?';
    let message = `Would you like to use local authentication instead of 2-Factor Authentication (2FA), when you ${loginSupported}release money to contractors or withdraw money?`;
    let message2 = 'Sign in with biometrics';
    let type = '';
    if (supportedAuthenticationTypesAsync){
      if (Platform.OS === 'ios') {
        if (supportedAuthenticationTypesAsync.includes(2)) {
          title = 'Use FaceID?';
          message = `Would you like to use FaceID, instead of 2-Factor Authentication (2FA), when you ${loginSupported}release money or withdraw money?`;
          message2 = 'Sign in with FaceID';
          type = 'facial';
        } else if (supportedAuthenticationTypesAsync.includes(1)) {
          title = 'Use TouchID?';
          message = `Would you like to use TouchID, instead of 2-Factor Authentication (2FA), when you ${loginSupported}release money or withdraw money?`;
          message2 = 'Sign in with TouchID';
          type = 'fingerprint';
        }
      } else if (Platform.OS === 'android') {
        if (supportedAuthenticationTypesAsync.includes(2)) {
          title = 'Use Facial Recognition?';
          message = `Would you like to use facial recognition, instead of 2-Factor Authentication (2FA), when you ${loginSupported}release money or withdraw money?`;
          message2 = 'Sign in with facial recognition';
          type = 'facial';
        } else if (supportedAuthenticationTypesAsync.includes(1)) {
          title = 'Use Fingerprint Recognition?';
          message = `Would you like to use fingerprint recognition, instead of 2-Factor Authentication (2FA), when you ${loginSupported}release money or withdraw money?`;
          message = 'Sign in with fingerprint recognition';
          type = 'fingerprint';
        }
      }
      console.log('message', message);
      // setLocalAuthenticationModalMessage(message);
      localAuthenticationModalTitle = title;
      localAuthenticationModalMessage = message;
      // SecureStore.setItemAsync('localAuthenticationMessage', message); // for message on profile
      // SecureStore.setItemAsync('localAuthenticationButtonText', message2); // for button on login screen
      // SecureStore.setItemAsync('localAuthenticationType', type);
      Storage.setItem('localAuthenticationMessage', message); // for message on profile
      Storage.setItem('localAuthenticationButtonText', message2); // for button on login screen
      Storage.setItem('localAuthenticationType', type);
      showLocalAuthenticationAlert(localAuthenticationModalTitle, localAuthenticationModalMessage);
    }
    
  }
  const showLocalAuthenticationAlert = (title, msg) => {
    Alert.alert(title, msg, [
      {
        text: 'No',
        onPress: () => {
          // SecureStore.setItemAsync('useLocalAuthentication', 'no');
          // SecureStore.deleteItemAsync('username');
          // SecureStore.deleteItemAsync('password');
          Storage.setItem('useLocalAuthentication', 'no');
          Storage.removeItem('username');
          Storage.removeItem('password');
        },
        style: 'cancel',
      },
      {
        text: 'Yes',
        // onPress: () => {
        //   SecureStore.setItemAsync('useLocalAuthentication', 'yes');
        // },
        onPress: () => {
          performLocalAuthentication();
        },
      }
    ],
    { cancelable: false }
    )
  }
  const performLocalAuthentication = async () => {
    let authenticateAsync = await LocalAthentication.authenticateAsync();
    console.log('authenticateAsync', authenticateAsync);
    if (authenticateAsync.success) {
      // SecureStore.setItemAsync('useLocalAuthentication', 'yes');
      Storage.setItem('useLocalAuthentication', 'yes');
    }
  }

  const selectAddress = (a) => {
    setSelectedAddress(a);
    getProjects(a);
    console.log('selectAddress', a);
  }

  const newProjectContainer = () => {
    return (
      <View style={styles.newProjectContainer} >
        <View style={styles.selectContainer}>
          <SelectBox
            // label="Show projects from"
            options={addresses}
            value={selectedAddress}
            onChange={selectAddress}
            hideInputFilter={true}
            arrowIconColor={Colors.yellow}
            labelStyle={{ display: 'none', }}
            optionsLabelStyle={{ color: Colors.lightText, padding: 8, backgroundColor: Colors.textInputBackground }}
            selectedItemStyle={{ color: Colors.yellow }}
            // optionContainerStyle={{ backgroundColor: 'red'}}
            optionContainerStyle={{ padding: 0, paddingVertical: 0, paddingRight: 0, flexDirection: 'column', alignItems: 'stretch' }}
            listEmptyLabelStyle={{ color: Colors.lightText, }}
          />
        </View>
        <TouchableOpacity onPress={() => newProject()} activeOpacity='0.6'>
          <Ionicons name="ios-add-circle" size={48} color={Colors.yellow} />
        </TouchableOpacity>
      </View >
    );
  }
  // const completedProjectsComponent = () => {
  //   if(completedProjects.length >= 1){
  //     return (
  //       <View>
  //         <Text style={[CS.smallTitle, CS.lightText]}>Completed</Text>
  //         <Carousel
  //           style='imageDispute'
  //           items={completedProjects}
  //           navigation={navigation}
  //         />
  //       </View>
  //     );
  //   }
  //   return null;
  // }
  const completedProjectsComponent = () => {
    if(completedProjects.length >= 1){
      // if (Platform.OS === 'web') {
      //   return (
      //     <View>
      //       <Text style={[CS.smallTitle, CS.lightText]}>Completed</Text>
      //       <FlatList
      //         data={completedProjects}
      //         renderItem={({ item }) => <ProjectPreview project={item} />}
      //         keyExtractor={item => item.id.toString()}
      //         horizontal={true}
      //       />
      //     </View>
      //   )
      // }
      return (
        <View style={{ marginBottom: 20 }}>
          <View style={[CS.rowContainer, { marginBottom: 20, alignItems: 'flex-end' }]}>
            <Text style={[CS.smallTitle, CS.lightText, { marginBottom: 0 }]}>Completed</Text>
            {showSeeAll &&
              <TouchableOpacity activeOpacity={0.6} onPress={() => linkTo('/completedprojects')} style={{ marginLeft: 'auto' }}>
                <Text style={[CS.miniText, CS.yellowText]}>See all</Text>
              </TouchableOpacity>
            }
          </View>
          <Carousel
            layout='default'
            ref={ref => carouselRef = ref}
            data={completedProjects}
            sliderWidth={isWeb ? 768 - 20 : SLIDER_WIDTH}
            itemWidth={((isTablet || isWeb) && screenWidth >= 768) ? ((768 - 30) / 2) : (SLIDER_WIDTH - 60)}
            // renderItem={renderItem}
            renderItem={({ item }) => <ProjectPreview project={item} />}
            onSnapToItem={index => setActiveIndex(index)}
            pagingEnabled={isWeb ? true : false}
            enableMomentum={true}
            decelerationRate={0.9}
          />
          {isWeb ? null : pagination()}
        </View>
      );
    }
    return null;
  }

  const pagination = () => {
    // const { entries, activeSlide } = this.state;
    return (
      <Pagination
        dotsLength={completedProjects.length}
        activeDotIndex={activeIndex}
        // containerStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.75)', }}
        containerStyle={{ paddingVertical: 10 }}
        dotStyle={{
          width: 10,
          height: 10,
          borderRadius: 5,
          marginHorizontal: 0,
          backgroundColor: Colors.yellow,
        }}
        inactiveDotStyle={{
          backgroundColor: Colors.lightGrey
        }}
        inactiveDotOpacity={0.4}
        inactiveDotScale={0.6}
      />
    );
  }

  // const inviteNotice = () => {
  //   if(Platform.OS !== 'web'){ return null; }
  //   return (
  //     <View style={styles.inviteNoticeContainer}>
  //       <Text style={[CS.smallText, CS.lightBlueText]}>If you were invited to a Project and you do not see it here, please go back to the invite in your email and click on the link again.</Text>
  //       <Text style={[CS.miniText, CS.lightBlueText, CS.italicText, { marginTop: 10 }]}>Note: Your email and this app must be in the same browser, preferably your default browser. If you are not able to have your email in the same browser as this application, please copy/paste the invite link into this browser this app is on.</Text>
  //     </View>
  //   )
  // }

  // const testAlert = () => {
  //   alert(JSON.stringify(user));
  // }

  return (
    <View style={CS.safe}>
      <BackgroundGradient />
      {Platform.OS === 'web' ?
        <Loader animating={loading} />
        : null}
      <View style={CS.innerContainer}>
        <ScrollView keyboardShouldPersistTaps='handled' ref={scrollRef} style={styles.container} contentContainerStyle={[styles.innerContainer, { paddingTop: insets.top, paddingBottom: insets.bottom }]}>
          {/* <Loader animating={loading} /> */}
          <Text style={[CS.largeText, CS.lightText, CS.centerText, CS.boldText, { marginVertical: 10 }]}>Projects</Text>
          {newProjectContainer()}
          {/* {inviteNotice()} */}
          {/* <View style={{ flexGrow: 1 }}> */}
          {isReady &&
            <FlashList
              data={projects}
              renderItem={({ item }) => <ProjectPreview project={item} />}
              ItemSeparatorComponent={() => (<View style={{ height: 10 }} />)}
              keyExtractor={item => item.id.toString()}
              // ListHeaderComponent={newProjectContainer}
              // ListFooterComponent={completedProjectsComponent}
              refreshControl={<RefreshControl refreshing={loading} onRefresh={() => getProjects(selectedAddress)} colors={[Colors.yellow]} tintColor={Colors.yellow} />}
              ListEmptyComponent={() => <Text style={[CS.smallText, CS.lightBlueText, CS.centerText]}>You have no projects in progress at the moment. Click the <Ionicons name="ios-add-circle" size={18} color={Colors.yellow} /> icon to start one.</Text>}
              numColumns={((isTablet || isWeb) && screenWidth >= 768) ? 2 : 1}
              // numColumns={2}
              horizontal={false}
              columnWrapperStyle={((isTablet || isWeb) && screenWidth >= 768) && { flex: 1, justifyContent: 'flex-start' }}
              estimatedItemSize={183}
            />
          }
          {/* </View> */}
          {completedProjectsComponent()}

          {/* <View style={{ padding: 20, backgroundColor: 'pink', alignItems: 'center', }}>
            <TouchableOpacity onPress={() => testAlert()}>
              <Text style={[CS.darkText, CS.mediumText]}>Test Alert</Text>
            </TouchableOpacity>
          </View> */}
        </ScrollView>
      </View>
    </View>
  );

}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    // marginVertical: 10,
    // backgroundColor: 'pink'
  },
  innerContainer: {
    width: '100%',
    // backgroundColor: 'blue',
    // maxWidth: Platform.OS === 'web' ? 768 : '100%',
    // justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
    flexGrow: 1,
    alignSelf: 'center',
  },
  newProjectContainer: {
    flexDirection: 'row',
    // alignItems: 'center',
    // justifyContent: 'flex-end',
    marginBottom: 10,
  },
  selectContainer: {
    flex: 1,
    marginRight: 10,
    marginTop: 10,
  },
  inviteNoticeContainer: {
    padding: 10,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: Colors.lightBlue2,
    // borderColor: Colors.yellow,
    backgroundColor: Colors.textInputBackground,
    marginBottom: 20,
  }
});